export const TWO_FACTOR_AUTH = {
    disabled: '2FA disabled',
    emailEnabled: '2FA using email'
}